import { Button, Form, Input } from "@shared/ui";
import { Trash2 } from "lucide-react";
import { ReactNode } from "react";
import styles from "./styles.module.scss";

type LinkFieldsProps = {
  name: string;
  label: string;
  placeholder: string;
  addLabel: string;
  emptyMessage: string;
  prefix?: ReactNode;
};

export function LinkFields({
  name,
  label,
  placeholder,
  addLabel,
  emptyMessage,
  prefix,
}: LinkFieldsProps) {
  return (
    <Form.List
      name={name}
      rules={[
        {
          validator: async (_, values: { url?: string }[]) => {
            if (!values?.length) throw new Error(emptyMessage);
          },
        },
      ]}
    >
      {(fields, { add, remove }, { errors }) => (
        <>
          {fields.map((field) => (
            <div className={styles.linkRow} key={field.key}>
              <Form.Item
                {...field}
                className={styles.linkField}
                label={label}
                name={[field.name, "url"]}
                rules={[
                  { required: true, message: `Enter ${label.toLowerCase()}` },
                  { type: "url", message: "Invalid URL" },
                ]}
              >
                <Input prefix={prefix} placeholder={placeholder} />
              </Form.Item>
              <button
                type="button"
                className={styles.removeBtn}
                aria-label={`Remove ${label.toLowerCase()}`}
                onClick={() => remove(field.name)}
              >
                <Trash2 size={14} />
              </button>
            </div>
          ))}
          <Button className={styles.addBtn} onClick={() => add({ url: "" })}>
            {addLabel}
          </Button>
          <Form.Item>
            <Form.ErrorList errors={errors} />
          </Form.Item>
        </>
      )}
    </Form.List>
  );
}
